import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { FarmService } from 'src/app/services/farm-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ThrowStmt } from '@angular/compiler';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { type } from 'os';

declare var $: any;

@Component({
  selector: 'smart-config-farm',
  templateUrl: './config-farm.component.html',
  styleUrls: ['./config-farm.component.scss']
})
export class ConfigFarmComponent implements OnInit {
  constructor(
  ) { }

  ngOnInit(): void {
  }
}
